<template>
	<div class="detalhes-estorno-item">
		<v-row>
			<v-col cols="12">
				<label-personalizado class="label titulo" nome-campo="Item"></label-personalizado>
				<texto-tooltip :texto="codigoDescricao" :tamanho-maximo="440"></texto-tooltip>
			</v-col>
		</v-row>
		<v-divider class="divider mb-2 mt-2"></v-divider>
		<listagem-itens
			:textos-do-template-da-listagem-vazia="textoListagemVazia"
			:colunas="colunas"
			:custom-columns="['quantidadeSolicitada', 'quantidadeEstornada', 'novoSaldo']"
			:itens="datasource"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem"
			:tamanho-maximo-colunas="tamanhoMaximoColunas"
		>
			<template #quantidadeSolicitada="{ item }">
				<span> {{ item.quantidadeSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
			</template>
			<template #quantidadeEstornada="{ item }">
				<span> {{ item.quantidadeEstornada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
			</template>
			<template #novoSaldo="{ item }">
				<span> {{ item.novoSaldo | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
			</template>
		</listagem-itens>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import ListagemItens from '@/views/components/ListagemItens.vue'
import { TabelaColunaUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { mapState } from 'vuex'

export default {
	name: 'historico-estorno-item-adesao',
	components: { ListagemItens, LabelPersonalizado },
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			codigoDescricao: '',
			datasource: [],
			totalItens: 0,
			totalPaginas: 0,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			textoListagemVazia: {
				titulo: 'Este item não possui estorno cadastrado.',
			},
			colunas: [
				new TabelaColunaUtils('Qtd. Solicitada', 'quantidadeSolicitada', '21%'),
				new TabelaColunaUtils('Qtd. Estornada', 'quantidadeEstornada', '21%'),
				new TabelaColunaUtils('Novo saldo', 'novoSaldo', '21%'),
				new TabelaColunaUtils('Justificativa', 'justificativa', '27%'),
				new TabelaColunaUtils('Data', 'data', '10%'),
			],
			tamanhoMaximoColunas: { justificativa: 27 },
		}
	},
	computed: {
		...mapState({
			numeroCasasDecimaisQtde: (state) => state.adesao.informacoesAdesao.numeroCasasDecimaisQtde,
		}),
	},
	async mounted() {
		await this.carregarHistorico()
	},
	methods: {
		async carregarHistorico() {
			const { codigoDescricao, itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ADESAO.ESTORNO.HISTORICO.BUSCAR,
				this.montarObjCarregarHistorico(),
			)

			this.codigoDescricao = codigoDescricao
			this.datasource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		montarObjCarregarHistorico() {
			return {
				idItemAdesao: { value: this.itemSelecionado.idItemAdesao },
				paginacao: this.paginacao,
			}
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.carregarHistorico()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.carregarHistorico()
		},
	},
}
</script>

<style lang="stylus" scoped>
.detalhes-estorno-item {
	.titulo {
		color var(--v-primary-base)
	}
	.label {
		font-size 14px !important
	}
	.divider {
		position: relative;
		right: 22px;
		width: 106% !important;
		max-width: none !important;
	}
}
</style>
